import {
  FETCH_AI_CONFIG,
  FETCH_AI_CONFIG_SUCCESS,
  FETCH_AI_CONFIG_FAILED,
  EDIT_AI_CONFIG,
} from '../store/types';

const INITIAL_STATE = {
  config: null,
  loading: false,
  error: { flag: false, msg: null },
};

export const aiconfigreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_AI_CONFIG:
      return { ...state, loading: true };
    case FETCH_AI_CONFIG_SUCCESS:
      return { ...state, config: action.payload, loading: false };
    case FETCH_AI_CONFIG_FAILED:
      return { ...state, config: null, loading: false, error: { flag: true, msg: action.payload } };
    case EDIT_AI_CONFIG:
      return state;
    default:
      return state;
  }
};
